import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import styles from './Doc.module.css';
import { patientActions } from '_actions'
import { AlButton } from '_components';

class PatientHomeCdvAl extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.doc_wrapper} onClick={() => this.props.openAl(this.props.id, this.props.ptno)}>
                    <div className={styles.doc_row}>
                        <div className={styles.icon}>
                            <AlButton size='extra-small' />
                        </div>
                        <div className={styles.icon}>
                        </div>
                        <div className={styles.icon}>
                        </div>
                        <div className={styles.iconSpace}>
                        </div>
                        <div className={styles.supervisior_icon}>
                        </div>

                        <div className={styles.doc_name}>
                            Activity Log
                        </div>
                        <div className={styles.doc_dos}>
                        </div>
                        <div className={styles.doc_visit}>
                        </div>
                        <div className={styles.doc_therapist}>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openAl: bindActionCreators(patientActions.openAl, dispatch)

    };
}


function mapStateToProps(state, ownprops) {
    return {
        ptno: state.ui.patients.selectedPtno
    };
}

const connectedPatientHomeCdvAl = connect(mapStateToProps, mapDispatchToProps)(PatientHomeCdvAl);
export { connectedPatientHomeCdvAl as PatientHomeCdvAl };

